import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import LoadingScreen from "@/components/LoadingScreen";
import CursorGlow from "@/components/CursorGlow";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function App() {
  const [loaded, setLoaded] = useState(
    typeof window !== "undefined" && window.location.search.includes("skipLoader")
  );

  return (
    <div className="App grain">
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <CursorGlow />
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  {!loaded && <LoadingScreen onDone={() => setLoaded(true)} />}
                  <Landing />
                </>
              }
            />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Legal type="privacy" />} />
            <Route path="/terms" element={<Legal type="terms" />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "rgba(20,20,20,0.85)",
              border: "1px solid rgba(212,175,55,0.3)",
              color: "#fff",
              backdropFilter: "blur(16px)",
            },
          }}
        />
      </ReactLenis>
    </div>
  );
}

export default App;
